import type { MetaShortDTO } from 'shared/types/api'
import { eventsDefinitions } from './events-definitions'
import type { ECommerceMetadata, EventMetadata } from './types'

type ActionPageMetadata = {
    type: 'PAGE_METADATA',
    payload: MetaShortDTO
}

type ActionEventMetadata = {
    type: 'EVENT_METADATA',
    payload: EventMetadata
}

type ActionECommerceMetadata = {
    type: 'ECOMMERCE_METADATA',
    payload: ECommerceMetadata
}

const pageMetadata = (payload: MetaShortDTO): ActionPageMetadata => ({
    type: 'PAGE_METADATA',
    payload
})

const eventMetadata = (payload: EventMetadata): ActionEventMetadata => ({
    type: 'EVENT_METADATA',
    payload
})

const eCommerceMetadata = (
    payload: ECommerceMetadata
): ActionECommerceMetadata => {
    return {
        type: 'ECOMMERCE_METADATA',
        payload
    }
}

export { pageMetadata, eventMetadata, eCommerceMetadata, eventsDefinitions }

export type Action =
    | ActionPageMetadata
    | ActionEventMetadata
    | ActionECommerceMetadata
